module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAqBAMAAAA37dRoAAAAG1BMVEUCev9Oov9grP9tsv+hzf+x1v/e7v/g7/////9mGrCWAAAARUlEQVQoz2NgGBxANBQIgoAMVRAjECoa0QEELUCGB4jRChNF0TlURVVQRJ3ICDOzcmSQjFeUFIDdZcMj1LGnKOypb6ABAGaHMHsMTsThAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/applicationDiscount/sys@2x.png
// module id = gBXk
// module chunks = 69